import type { TAccountDTO, TOptionWithType } from "./accountTypes";

export const getAccountOptionsWithTypes = (
    accounts: TAccountDTO[] | null,
): TOptionWithType[] => {
    const availableAccounts = accounts ?? [];
    return availableAccounts.map(account => ({
        label: account.account,
        value: account.code,
        type: account.type,
        subcategory: account.subcategory,
    }));
};
